import React, { Component, div } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { is } from "immutable";
import { ErrorMobileModal } from "component/modal";
import { ErrorModal } from "component/modal";
import translations from "translations";
import { ReactComponent as DangerIcon } from "assets/icons/danger.svg";
import "containers/Error/styles.scss";

class Error extends Component {
  constructor(props) {
    super(props);
    this.refreshHandler = this._refreshHandler.bind(this);
    this.goToExitUrl = this._goToExitUrl.bind(this);
    this.getButtons = this._getButtons.bind(this);
  }

  _refreshHandler() {
    window.location.reload();
  }

  _goToExitUrl() {
    this.props.fetchExit(this.props.exitLink).then((response) => {
      if (!response.url) {
        window.location.reload();
      } else {
        window.location.href = response.url;
      }
    });
  }

  getHeader(status) {
    switch (status) {
      case 503:
        return <DangerIcon />;
      default:
        return null;
    }
  }

  _getButtons(status, key) {
    switch (status) {
      case 401:
        if (!this.props.exitLink) {
          return null;
        }
        return (
          <div className="w-100 center">
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={this.goToExitUrl}
            >
              {translations("ok")}
            </button>
          </div>
        );
      case 503:
        return (
          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={this.refreshHandler}
          >
            {translations("refresh")}
          </button>
        );
      default:
        return (
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              this.props.confirmError({ key });
            }}
          >
            {translations("close")}
          </button>
        );
    }
  }
  getMessage(status, message) {
    switch (status) {
      case 401:
        return (
          <div>
            <h6 className="center yellow">{translations("sessionExpired")}</h6>
            <h6 className="center">{translations("loginAgain")}</h6>
          </div>
        );
      case 403:
        return (
          <div>
            <h6 className="center yellow">{translations("sessionInUse")}</h6>
            <h6 className="center">{translations("userAlreadyLoggedIn")}</h6>
          </div>
        );
      case 417:
        return (
          <div>
            <h6 className="center yellow">{translations("sessionInUse")}</h6>
            <h6 className="center">{translations("userAlreadyLoggedIn")}</h6>
          </div>
        );
      case 503:
        return (
          <div>
            <h5>{translations("error503")}</h5>
            <h6>{translations("tryAgain")}</h6>
          </div>
        );
      default:
        return (
          <div>
            <h6 className="center yellow">{message}</h6>
          </div>
        );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.error && !is(this.props.error, prevProps.error)) {
      if (this.props.error.size === 0) {
        this.props.hideModal("ERROR");
      } else {
        this.props.broadcastSessionExpired();
        this.props.showModal("ERROR");
      }
    }
  }

  renderDefaultMessage(message) {
    return (
      <div>
        <h6 className="center yellow">{translations("somethingWentWrong")}</h6>
        <h6 className="center">{translations("pleaseTryAgain")}</h6>
      </div>
    );
  }

  render() {
    if (this.props.error.size === 0) {
      return null;
    }

    return (
      <div className="applicationError">
        {this.props.error.map((error, key) => {
          let EModal = this.props.isMobile ? ErrorMobileModal : ErrorModal;
          let status;
          let message;

          try {
            status = error.response.status;
          } catch (err) {}

          try {
            message = this.renderDefaultMessage(error.message);
          } catch (err) {}

          let buttons = this.getButtons(status, key);
          let statusMessage = this.getMessage(status, message);
          let header = this.getHeader(status);
          return (
            <EModal
              key={key}
              header={header}
              message={statusMessage ? statusMessage : message}
              buttons={buttons}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let exitLink;
  let error;
  try {
    exitLink = state.profile.get("links").find((link) => {
      return link.get("rel") === "exit";
    });
  } catch (err) {}

  if (state.error) {
    error = state.error.filter((e) => {
      return e.response;
    });
  }

  return {
    newErr: error,
    exitLink: exitLink,
    error: error,
    isMobile: state.window.get("isMobile"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchUrl: () => dispatchProps.fetchUrl(),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchExit: (route) => dispatchProps.fetchExit(route),
    broadcastSessionExpired: () => dispatchProps.broadcastSessionExpired(),
    confirmError: (payload) => dispatchProps.confirmError(payload),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Error);
